import React from 'react';
import type { Size } from '../../types';

const lazyNft = (width: Size = '289', height: Size = '398') => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 289 398"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M279.639 225.452C282.949 198.296 278.132 170.769 265.798 146.35C253.464 121.932 234.167 101.718 210.346 88.2667C186.525 74.8148 159.25 68.7283 131.97 70.7767C104.69 72.8251 78.63 82.9164 57.0849 99.7746C35.5398 116.633 19.4772 139.501 10.9281 165.488C2.3789 191.474 1.72709 219.412 9.05506 245.769C16.383 272.126 31.3617 295.719 52.0972 313.563C72.8326 331.408 98.3937 342.704 125.548 346.022C143.583 348.226 161.876 346.855 179.381 341.988C196.886 337.121 213.261 328.854 227.57 317.657C241.879 306.461 253.843 292.555 262.777 276.734C271.711 260.913 277.441 243.487 279.639 225.452Z"
                fill="#FF6CD0"
            />
            <path
                d="M83.8893 133.126L104.349 130.392L118.053 123.186C118.053 123.186 135.199 126.403 117.796 110.318C107.148 100.506 99.7165 101.665 83.1172 89.3115C70.5391 79.9181 65.5529 73.8703 58.6365 74.1599C52.1061 85.9981 79.4499 122.51 83.8893 133.126Z"
                fill="url(#paint0_linear_9907_50791)"
            />
            <path
                d="M55.4196 165.392C55.4196 165.392 42.0694 152.138 45.7689 120.162C47.3096 104.65 51.2038 89.4639 57.3176 75.125C57.477 74.8147 57.7261 74.5596 58.0326 74.3929C58.339 74.2262 58.6885 74.1556 59.0356 74.1903C59.3827 74.225 59.7114 74.3634 59.9787 74.5875C60.246 74.8116 60.4397 75.111 60.5345 75.4467C63.3011 85.8695 86.7846 101.986 99.5557 123.7L55.4196 165.392Z"
                fill="url(#paint1_linear_9907_50791)"
            />
            <path
                d="M226.174 74.192C219.225 73.9024 214.271 79.9502 201.661 89.3436C185.094 101.697 177.662 100.667 167.014 110.318C149.45 126.403 166.628 123.186 166.628 123.186L180.3 130.456L200.792 133.19C205.231 122.51 232.575 85.9981 226.174 74.192Z"
                fill="url(#paint2_linear_9907_50791)"
            />
            <path
                d="M185.094 123.668C197.961 102.018 221.348 85.9017 224.115 75.4146C224.21 75.0789 224.403 74.7795 224.671 74.5554C224.938 74.3313 225.267 74.1929 225.614 74.1582C225.961 74.1234 226.31 74.194 226.617 74.3608C226.923 74.5275 227.172 74.7826 227.332 75.0929C233.432 89.4362 237.326 104.621 238.88 120.13C242.58 152.106 229.23 165.36 229.23 165.36L185.094 123.668Z"
                fill="url(#paint3_linear_9907_50791)"
            />
            <path
                d="M232.414 252.603C274.234 204.349 204.91 105.493 143.306 107.552C119.983 105.847 65.1991 127.979 47.7634 180.158C-1.77711 294.262 186.702 308.03 232.414 252.603Z"
                fill="url(#paint4_radial_9907_50791)"
            />
            <path
                d="M183.549 186.302C196.697 186.302 207.355 176.926 207.355 165.359C207.355 153.793 196.697 144.417 183.549 144.417C170.402 144.417 159.744 153.793 159.744 165.359C159.744 176.926 170.402 186.302 183.549 186.302Z"
                fill="url(#paint5_radial_9907_50791)"
            />
            <path
                d="M101.1 186.302C114.247 186.302 124.905 176.926 124.905 165.359C124.905 153.793 114.247 144.417 101.1 144.417C87.9526 144.417 77.2946 153.793 77.2946 165.359C77.2946 176.926 87.9526 186.302 101.1 186.302Z"
                fill="url(#paint6_radial_9907_50791)"
            />
            <path
                d="M150.544 209.335C148.922 209.412 147.326 208.91 146.04 207.92C144.976 206.995 144.317 205.69 144.206 204.284V196.886C144.206 196.752 144.233 196.62 144.285 196.496C144.337 196.373 144.414 196.262 144.51 196.169C144.606 196.076 144.72 196.003 144.844 195.955C144.969 195.907 145.102 195.884 145.236 195.888C145.503 195.888 145.761 195.992 145.953 196.178C146.145 196.365 146.257 196.618 146.265 196.886V204.252C146.352 205.079 146.756 205.84 147.391 206.375C148.076 206.826 148.847 207.13 149.656 207.268C150.464 207.407 151.292 207.376 152.088 207.18C153.847 206.902 155.437 205.975 156.545 204.581C157.653 203.187 158.198 201.428 158.071 199.652C158.063 199.384 158.158 199.124 158.339 198.926C158.519 198.727 158.769 198.607 159.036 198.591C159.173 198.565 159.314 198.572 159.447 198.61C159.581 198.648 159.704 198.716 159.807 198.81C159.91 198.903 159.989 199.019 160.04 199.148C160.09 199.278 160.11 199.417 160.098 199.556C160.269 201.842 159.568 204.109 158.135 205.899C156.703 207.69 154.646 208.871 152.377 209.206C151.77 209.295 151.157 209.338 150.544 209.335Z"
                fill="#051140"
            />
            <path
                d="M138.963 209.335C138.363 209.382 137.761 209.382 137.162 209.335C134.887 209.007 132.822 207.829 131.383 206.037C129.944 204.246 129.239 201.975 129.409 199.684C129.425 199.417 129.546 199.166 129.744 198.986C129.942 198.806 130.203 198.71 130.47 198.719C130.741 198.735 130.994 198.854 131.18 199.052C131.365 199.249 131.468 199.51 131.468 199.781C131.349 201.555 131.896 203.31 133.003 204.702C134.109 206.095 135.695 207.024 137.451 207.308C138.247 207.503 139.075 207.532 139.883 207.394C140.691 207.255 141.462 206.953 142.148 206.504C142.791 205.96 143.195 205.187 143.274 204.349V196.885C143.274 196.612 143.382 196.351 143.575 196.157C143.768 195.964 144.03 195.856 144.303 195.856C144.576 195.856 144.838 195.964 145.031 196.157C145.224 196.351 145.333 196.612 145.333 196.885V204.252C145.289 204.952 145.108 205.637 144.799 206.266C144.49 206.895 144.059 207.457 143.531 207.919C142.228 208.925 140.606 209.427 138.963 209.335Z"
                fill="#051140"
            />
            <path
                d="M156.656 190.741C155.787 188.296 154.147 187.717 144.593 187.717C135.038 187.717 133.43 188.296 132.561 190.741C131.693 193.186 133.88 195.245 144.593 197.818C155.273 195.245 157.364 192.928 156.656 190.741Z"
                fill="url(#paint7_radial_9907_50791)"
            />
            <path
                d="M146.973 192.06C148.807 192.06 150.19 191.417 150.19 190.613C150.19 189.808 148.71 189.165 146.973 189.165C145.236 189.165 143.756 189.808 143.756 190.613C143.756 191.417 145.139 192.06 146.973 192.06Z"
                fill="white"
            />
            <path
                d="M101.711 178.131C93.4651 178.428 85.3746 175.833 78.8388 170.796C78.7206 170.693 78.6238 170.567 78.5541 170.426C78.4845 170.285 78.4432 170.132 78.4328 169.975C78.4223 169.818 78.4428 169.661 78.4932 169.512C78.5436 169.363 78.6227 169.226 78.7262 169.107C78.8297 168.989 78.9555 168.892 79.0964 168.823C79.2373 168.753 79.3905 168.712 79.5474 168.701C79.7042 168.691 79.8616 168.711 80.0104 168.762C80.1593 168.812 80.2968 168.891 80.4151 168.995C86.5232 173.63 94.0487 176.006 101.711 175.718C109.374 176.012 116.902 173.635 123.007 168.995C123.246 168.786 123.558 168.68 123.875 168.701C124.192 168.722 124.487 168.869 124.696 169.107C124.905 169.346 125.011 169.658 124.989 169.975C124.968 170.292 124.822 170.587 124.583 170.796C118.048 175.833 109.957 178.428 101.711 178.131Z"
                fill="#051140"
            />
            <path
                d="M183.035 178.131C174.789 178.427 166.698 175.833 160.162 170.796C160.049 170.685 159.958 170.553 159.896 170.406C159.835 170.26 159.803 170.103 159.803 169.944C159.803 169.785 159.835 169.628 159.896 169.481C159.958 169.335 160.049 169.202 160.162 169.091C160.391 168.869 160.696 168.745 161.015 168.745C161.333 168.745 161.639 168.869 161.867 169.091C167.973 173.732 175.5 176.108 183.163 175.815C190.826 176.103 198.351 173.727 204.459 169.091C204.698 168.882 205.01 168.777 205.327 168.798C205.644 168.819 205.939 168.965 206.148 169.204C206.357 169.443 206.463 169.755 206.442 170.072C206.421 170.388 206.274 170.684 206.036 170.893C199.452 175.924 191.313 178.485 183.035 178.131Z"
                fill="#051140"
            />
            <path
                d="M142.727 152.653C158.521 152.653 171.325 139.849 171.325 124.054C171.325 108.26 158.521 95.4561 142.727 95.4561C126.932 95.4561 114.128 108.26 114.128 124.054C114.128 139.849 126.932 152.653 142.727 152.653Z"
                fill="url(#paint8_radial_9907_50791)"
            />
            <path
                d="M141.15 138.659C152.095 138.659 160.967 129.787 160.967 118.843C160.967 107.899 152.095 99.0267 141.15 99.0267C130.206 99.0267 121.334 107.899 121.334 118.843C121.334 129.787 130.206 138.659 141.15 138.659Z"
                fill="url(#paint9_radial_9907_50791)"
            />
            <path
                d="M141.15 124.891C150.673 124.891 158.393 117.171 158.393 107.648C158.393 98.1251 150.673 90.4053 141.15 90.4053C131.628 90.4053 123.908 98.1251 123.908 107.648C123.908 117.171 131.628 124.891 141.15 124.891Z"
                fill="url(#paint10_radial_9907_50791)"
            />
            <path
                d="M141.15 112.28C149.252 112.28 155.819 105.713 155.819 97.6113C155.819 89.5097 149.252 82.9421 141.15 82.9421C133.049 82.9421 126.481 89.5097 126.481 97.6113C126.481 105.713 133.049 112.28 141.15 112.28Z"
                fill="url(#paint11_radial_9907_50791)"
            />
            <path
                d="M141.151 100.828C147.831 100.828 153.246 95.413 153.246 88.7328C153.246 82.0526 147.831 76.6372 141.151 76.6372C134.47 76.6372 129.055 82.0526 129.055 88.7328C129.055 95.413 134.47 100.828 141.151 100.828Z"
                fill="url(#paint12_radial_9907_50791)"
            />
            <path
                d="M141.15 87.0598C146.409 87.0598 150.673 82.7966 150.673 77.5377C150.673 72.2788 146.409 68.0156 141.15 68.0156C135.892 68.0156 131.628 72.2788 131.628 77.5377C131.628 82.7966 135.892 87.0598 141.15 87.0598Z"
                fill="url(#paint13_radial_9907_50791)"
            />
            <path
                d="M141.15 75.8971C144.988 75.8971 148.099 72.7861 148.099 68.9485C148.099 65.111 144.988 62 141.15 62C137.313 62 134.202 65.111 134.202 68.9485C134.202 72.7861 137.313 75.8971 141.15 75.8971Z"
                fill="url(#paint14_radial_9907_50791)"
            />
            <path
                d="M142.534 245.654C179.11 245.654 208.77 253.889 208.77 264.055C208.77 274.22 179.11 282.455 142.534 282.455C105.957 282.455 76.3296 274.381 76.3296 264.055C76.3296 253.728 105.99 245.654 142.534 245.654Z"
                fill="url(#paint15_radial_9907_50791)"
            />
            <path
                d="M238.012 251.895H237.98C236.612 251.895 235.503 253.004 235.503 254.372V320.898C235.503 322.266 236.612 323.375 237.98 323.375H238.012C239.38 323.375 240.489 322.266 240.489 320.898V254.372C240.489 253.004 239.38 251.895 238.012 251.895Z"
                fill="url(#paint16_linear_9907_50791)"
            />
            <path
                d="M246.054 256.013C246.355 253.975 245.893 251.898 244.758 250.179C243.622 248.461 241.892 247.222 239.9 246.7C237.907 246.178 235.792 246.41 233.96 247.35C232.127 248.291 230.707 249.875 229.97 251.798C229.748 252.274 229.617 252.787 229.584 253.31C229.283 255.348 229.744 257.425 230.88 259.143C232.016 260.862 233.746 262.101 235.738 262.623C237.731 263.145 239.846 262.913 241.678 261.973C243.51 261.032 244.931 259.448 245.668 257.525C245.89 257.049 246.021 256.536 246.054 256.013Z"
                fill="url(#paint17_radial_9907_50791)"
            />
            <path
                opacity="0.25"
                d="M103.287 260.966H185.351V291.012C185.834 292.91 181.845 323.825 173.384 325.272C154.179 327.998 134.685 327.998 115.48 325.272C107.051 323.825 103.062 292.91 103.513 291.012L103.287 260.966Z"
                fill="url(#paint18_linear_9907_50791)"
            />
            <path
                opacity="0.25"
                d="M109.464 238.995H179.11V290.176C179.496 291.785 176.118 322.345 168.945 323.632C152.609 325.948 136.029 325.948 119.694 323.632C112.52 322.41 109.142 291.785 109.528 290.176L109.464 238.995Z"
                fill="url(#paint19_linear_9907_50791)"
            />
            <path
                opacity="0.6"
                d="M142.96 297.394C200.311 296.821 246.723 288.391 246.625 278.566C246.526 268.741 199.955 261.242 142.605 261.815C85.2542 262.389 38.8422 270.818 38.9404 280.643C39.0387 290.468 85.61 297.968 142.96 297.394Z"
                fill="url(#paint20_radial_9907_50791)"
            />
            <path
                opacity="0.6"
                d="M142.379 316.805C188.499 316.443 225.837 309.755 225.775 301.867C225.713 293.978 188.275 287.878 142.154 288.24C96.0339 288.602 58.696 295.29 58.758 303.178C58.8199 311.066 96.2582 317.167 142.379 316.805Z"
                fill="url(#paint21_radial_9907_50791)"
            />
            <path
                opacity="0.6"
                d="M142.344 328.804C176.384 328.536 203.941 323.596 203.896 317.768C203.85 311.941 176.218 307.434 142.179 307.701C108.139 307.969 80.5815 312.909 80.6272 318.736C80.673 324.564 108.305 329.071 142.344 328.804Z"
                fill="url(#paint22_radial_9907_50791)"
            />
            <g opacity="0.7">
                <path
                    opacity="0.7"
                    d="M118.246 332.896H167.014V259.068H118.246V332.896Z"
                    fill="url(#paint23_linear_9907_50791)"
                />
            </g>
            <path
                d="M200.181 330.58L200.406 351.844H190.466C188.536 352.327 186.412 352.809 184.032 353.26C157.687 357.226 130.912 357.432 104.51 353.871C102.033 353.485 99.8773 353.034 98.0759 352.584H88.1034L87.8782 331.32C87.8782 328.875 93.3148 326.366 104.285 324.404C130.639 320.427 157.424 320.21 183.839 323.76C194.648 325.851 200.149 328.103 200.181 330.58Z"
                fill="url(#paint24_linear_9907_50791)"
            />
            <path
                d="M88.1999 331.61L88.4251 352.713H87.9104L87.6852 331.449C87.6852 329.262 92.0924 327.01 100.875 325.176C92.4141 327.074 88.1677 329.358 88.1999 331.61Z"
                fill="#DEFCF2"
            />
            <path
                d="M199.537 351.844L199.28 330.773C199.28 328.296 193.779 325.884 182.745 324.082C156.342 320.521 129.568 320.727 103.223 324.694L100.006 325.337C101.261 325.047 102.612 324.79 104.027 324.533C130.381 320.555 157.167 320.339 183.582 323.889C194.583 325.691 200.084 328.103 200.117 330.58L200.342 351.844H199.537Z"
                fill="#DEFCF2"
            />
            <path
                d="M144.921 361.585C175.995 361.274 201.142 356.716 201.089 351.404C201.036 346.092 175.802 342.037 144.729 342.348C113.655 342.659 88.5078 347.217 88.5609 352.529C88.614 357.841 113.847 361.896 144.921 361.585Z"
                fill="url(#paint25_linear_9907_50791)"
            />
            <path
                d="M105.957 359.308C119.327 361.221 132.826 362.082 146.33 361.881C132.345 362.204 118.358 361.375 104.51 359.404C87.3637 356.605 83.4069 352.23 93.1542 348.66C84.6937 352.295 89.0043 356.541 105.957 359.308Z"
                fill="#DEFCF2"
            />
            <path
                d="M184 358.793C178.177 359.822 171.357 360.594 164.119 361.141C170.553 360.594 176.73 359.887 182.038 358.922C203.945 354.997 203.913 348.885 182.038 345.314C162.263 342.633 142.261 342.051 122.364 343.577C142.874 341.888 163.507 342.416 183.903 345.153C205.875 348.756 205.939 354.804 184 358.793Z"
                fill="#DEFCF2"
            />
            <path
                d="M54.4868 240.475C54.4868 239.231 53.4858 238.223 52.251 238.223C51.0162 238.223 50.0153 239.231 50.0153 240.475V300.245C50.0153 301.489 51.0162 302.497 52.251 302.497C53.4858 302.497 54.4868 301.489 54.4868 300.245V240.475Z"
                fill="url(#paint26_linear_9907_50791)"
            />
            <path
                d="M59.5373 241.922C59.8094 240.088 59.3949 238.218 58.3731 236.67C57.3514 235.122 55.7943 234.006 54.0005 233.536C52.2068 233.066 50.3025 233.274 48.6528 234.121C47.0031 234.968 45.7242 236.394 45.0612 238.126C44.8457 238.545 44.7249 239.006 44.7073 239.477C44.4352 241.312 44.8497 243.182 45.8715 244.729C46.8932 246.277 48.4503 247.393 50.2441 247.863C52.0378 248.334 53.9421 248.125 55.5918 247.278C57.2415 246.431 58.5204 245.005 59.1834 243.273C59.3799 242.847 59.4997 242.39 59.5373 241.922Z"
                fill="url(#paint27_radial_9907_50791)"
            />
            <path
                d="M256.22 200.585C256.22 199.714 255.514 199.008 254.643 199.008C253.773 199.008 253.067 199.714 253.067 200.585V242.887C253.067 243.758 253.773 244.463 254.643 244.463C255.514 244.463 256.22 243.758 256.22 242.887V200.585Z"
                fill="url(#paint28_linear_9907_50791)"
            />
            <path
                d="M259.79 201.614C259.89 200.373 259.551 199.137 258.832 198.121C258.113 197.105 257.059 196.374 255.856 196.056C254.653 195.738 253.376 195.853 252.249 196.381C251.121 196.909 250.215 197.816 249.689 198.944C249.526 199.228 249.437 199.549 249.432 199.877C249.275 201.158 249.588 202.452 250.312 203.52C251.035 204.588 252.121 205.358 253.369 205.688C254.616 206.018 255.941 205.884 257.098 205.313C258.255 204.741 259.165 203.77 259.662 202.579C259.753 202.266 259.797 201.94 259.79 201.614Z"
                fill="url(#paint29_radial_9907_50791)"
            />
            <g opacity="0.7">
                <path
                    opacity="0.7"
                    d="M35.0243 180.962C35.0243 179.665 33.9801 178.613 32.692 178.613C31.4039 178.613 30.3597 179.665 30.3597 180.962V243.37C30.3597 244.667 31.4039 245.718 32.692 245.718C33.9801 245.718 35.0243 244.667 35.0243 243.37V180.962Z"
                    fill="url(#paint30_linear_9907_50791)"
                />
            </g>
            <path
                d="M41.0721 182.313C41.3729 180.275 40.9113 178.198 39.7756 176.48C38.64 174.761 36.9101 173.522 34.9176 173C32.9251 172.478 30.81 172.71 28.9777 173.651C27.1453 174.591 25.7245 176.175 24.9875 178.099C24.7623 178.562 24.631 179.065 24.6015 179.578C24.3007 181.616 24.7623 183.693 25.898 185.412C27.0336 187.13 28.7635 188.369 30.756 188.891C32.7485 189.413 34.8636 189.181 36.6959 188.241C38.5283 187.3 39.9491 185.716 40.6861 183.793C40.9039 183.327 41.0348 182.826 41.0721 182.313Z"
                fill="url(#paint31_radial_9907_50791)"
            />
            <path
                d="M15.7551 237.258H15.7229C14.8701 237.258 14.1788 237.949 14.1788 238.802V280.429C14.1788 281.282 14.8701 281.973 15.7229 281.973H15.7551C16.6079 281.973 17.2992 281.282 17.2992 280.429V238.802C17.2992 237.949 16.6079 237.258 15.7551 237.258Z"
                fill="url(#paint32_linear_9907_50791)"
            />
            <path
                d="M23.2182 240.539C23.4561 238.723 23.0237 236.882 22.0019 235.362C20.9802 233.842 19.4392 232.746 17.6677 232.281C15.8962 231.815 14.0157 232.012 12.3786 232.833C10.7415 233.655 9.45998 235.045 8.77424 236.743C8.57775 237.169 8.45796 237.627 8.42038 238.094C8.14825 239.929 8.5628 241.799 9.58455 243.346C10.6063 244.894 12.1633 246.01 13.9571 246.48C15.7509 246.951 17.6552 246.742 19.3049 245.895C20.9545 245.048 22.2335 243.622 22.8965 241.89C23.1008 241.469 23.2106 241.007 23.2182 240.539Z"
                fill="url(#paint33_radial_9907_50791)"
            />
            <path
                d="M272.915 238.03C272.915 237.053 272.123 236.261 271.146 236.261C270.169 236.261 269.377 237.053 269.377 238.03V285.126C269.377 286.103 270.169 286.895 271.146 286.895C272.123 286.895 272.915 286.103 272.915 285.126V238.03Z"
                fill="url(#paint34_linear_9907_50791)"
            />
            <path
                d="M276.84 239.188C277.063 237.742 276.742 236.264 275.94 235.04C275.137 233.816 273.909 232.933 272.494 232.561C271.079 232.19 269.576 232.355 268.275 233.027C266.975 233.698 265.969 234.827 265.452 236.196C265.295 236.531 265.197 236.89 265.163 237.258C264.977 238.693 265.321 240.146 266.13 241.346C266.939 242.546 268.157 243.41 269.557 243.777C270.957 244.143 272.442 243.987 273.735 243.338C275.028 242.689 276.041 241.591 276.583 240.25C276.747 239.92 276.835 239.557 276.84 239.188Z"
                fill="url(#paint35_radial_9907_50791)"
            />
            <path
                d="M219.129 148.31L228.425 137.855H219.45V133.512H235.535V137.244L226.206 147.699H235.503V152.138H219.129V148.31Z"
                fill="url(#paint36_linear_9907_50791)"
            />
            <path
                d="M254.901 96.0029L274.202 74.2566H255.544V65.2814H289V73.002L269.699 94.7483H289V103.884H254.901V96.0029Z"
                fill="url(#paint37_linear_9907_50791)"
            />
            <path
                d="M241.486 132.29L255.705 116.205H241.969V109.643H266.546V115.369L252.359 131.454H266.546V137.984H241.486V132.29Z"
                fill="url(#paint38_linear_9907_50791)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_9907_50791"
                    x1="84.7257"
                    y1="107.101"
                    x2="95.8884"
                    y2="93.1075"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9EAAEA" />
                    <stop offset="0.14" stopColor="#8192DF" />
                    <stop offset="0.3" stopColor="#5066C9" />
                    <stop offset="0.44" stopColor="#233EB4" />
                    <stop offset="0.52" stopColor="#0D2AAC" />
                    <stop offset="1" stopColor="#FF6CD0" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_9907_50791"
                    x1="94.3122"
                    y1="117.138"
                    x2="56.256"
                    y2="119.84"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2525C6" />
                    <stop offset="1" stopColor="#4D91EE" />
                </linearGradient>
                <linearGradient
                    id="paint2_linear_9907_50791"
                    x1="190.176"
                    y1="115.143"
                    x2="175.7"
                    y2="100.667"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#9EAAEA" />
                    <stop offset="0.14" stopColor="#8192DF" />
                    <stop offset="0.3" stopColor="#5066C9" />
                    <stop offset="0.44" stopColor="#233EB4" />
                    <stop offset="0.52" stopColor="#0D2AAC" />
                    <stop offset="1" stopColor="#FF6CD0" />
                </linearGradient>
                <linearGradient
                    id="paint3_linear_9907_50791"
                    x1="195.002"
                    y1="111.926"
                    x2="230.388"
                    y2="116.752"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2525C6" />
                    <stop offset="1" stopColor="#4D91EE" />
                </linearGradient>
                <radialGradient
                    id="paint4_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(143.53 200.391) rotate(90) scale(86.8568 127.839)"
                >
                    <stop stopColor="#B2E5F5" />
                    <stop offset="0.251083" stopColor="#A2D5FC" />
                    <stop offset="0.56" stopColor="#66AFF9" />
                    <stop offset="0.78" stopColor="#4593E3" />
                    <stop offset="0.91" stopColor="#3389E2" />
                    <stop offset="1" stopColor="#9CFFFC" />
                </radialGradient>
                <radialGradient
                    id="paint5_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(179.914 171.973) scale(17.7895 25.4391)"
                >
                    <stop stopColor="#65AEF8" stopOpacity="0.5" />
                    <stop
                        offset="0.26"
                        stopColor="#6BB2F9"
                        stopOpacity="0.33"
                    />
                    <stop
                        offset="0.58"
                        stopColor="#72B6F9"
                        stopOpacity="0.15"
                    />
                    <stop
                        offset="0.83"
                        stopColor="#76B9FA"
                        stopOpacity="0.04"
                    />
                    <stop offset="0.98" stopColor="#77BAFA" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint6_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(67244.9 -190.063) rotate(180) scale(263.285 331.217)"
                >
                    <stop stopColor="#65AEF8" stopOpacity="0.5" />
                    <stop
                        offset="0.26"
                        stopColor="#6BB2F9"
                        stopOpacity="0.33"
                    />
                    <stop
                        offset="0.58"
                        stopColor="#72B6F9"
                        stopOpacity="0.15"
                    />
                    <stop
                        offset="0.83"
                        stopColor="#76B9FA"
                        stopOpacity="0.04"
                    />
                    <stop offset="0.98" stopColor="#77BAFA" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint7_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(145.138 198.783) rotate(-63.4349) scale(10.7899 13.8604)"
                >
                    <stop offset="0.47" stopColor="#051140" />
                    <stop offset="1" stopColor="#FF6CD0" />
                </radialGradient>
                <radialGradient
                    id="paint8_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(148.903 127.368) scale(22.2289)"
                >
                    <stop stopColor="#2F42D0" />
                    <stop offset="1" stopColor="#3684A6" stopOpacity="0" />
                </radialGradient>
                <radialGradient
                    id="paint9_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(141.343 129.33) scale(17.9826)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFB9D7" />
                </radialGradient>
                <radialGradient
                    id="paint10_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(142.148 116.977) scale(17.2427)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFC0E1" />
                </radialGradient>
                <radialGradient
                    id="paint11_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(141.408 103.981) scale(14.6691)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFCCDC" />
                </radialGradient>
                <radialGradient
                    id="paint12_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(141.665 93.1078) scale(12.0956)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFCCDE" />
                </radialGradient>
                <radialGradient
                    id="paint13_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(141.665 81.012) scale(9.52208)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFCCD5" />
                </radialGradient>
                <radialGradient
                    id="paint14_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(141.279 70.75) scale(6.94854)"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#FFCCC8" />
                </radialGradient>
                <radialGradient
                    id="paint15_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(146.747 264.731) rotate(1.36393) scale(67.5744 17.8321)"
                >
                    <stop offset="0.32" stopColor="#9CFFFC" />
                    <stop
                        offset="0.33"
                        stopColor="#9BFEFC"
                        stopOpacity="0.98"
                    />
                    <stop
                        offset="0.52"
                        stopColor="#88ECF9"
                        stopOpacity="0.64"
                    />
                    <stop
                        offset="0.69"
                        stopColor="#78DEF7"
                        stopOpacity="0.37"
                    />
                    <stop
                        offset="0.84"
                        stopColor="#6DD4F5"
                        stopOpacity="0.17"
                    />
                    <stop
                        offset="0.94"
                        stopColor="#67CDF4"
                        stopOpacity="0.05"
                    />
                    <stop offset="1" stopColor="#64CBF4" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint16_linear_9907_50791"
                    x1="237.98"
                    y1="253.342"
                    x2="237.98"
                    y2="322.506"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop
                        offset="0.82"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint17_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(201.576 220.422) rotate(-30.1735) scale(8.12837)"
                >
                    <stop offset="0.01" stopColor="#CFF9FC" />
                    <stop offset="0.41" stopColor="#96F2F1" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint18_linear_9907_50791"
                    x1="144.271"
                    y1="327.299"
                    x2="144.271"
                    y2="260.934"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="#9CFFFC" />
                    <stop offset="0.04" stopColor="#94F1F1" />
                    <stop offset="0.19" stopColor="#72B6C2" />
                    <stop offset="0.34" stopColor="#558499" />
                    <stop offset="0.49" stopColor="#3D5A78" />
                    <stop offset="0.63" stopColor="#2B3A5E" />
                    <stop offset="0.76" stopColor="#1E244C" />
                    <stop offset="0.89" stopColor="#161641" />
                    <stop offset="1" stopColor="#13113D" />
                </linearGradient>
                <linearGradient
                    id="paint19_linear_9907_50791"
                    x1="144.271"
                    y1="325.369"
                    x2="144.271"
                    y2="239.059"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop offset="0.01" stopColor="#70E8FC" />
                    <stop offset="0.15" stopColor="#5AB5CF" />
                    <stop offset="0.3" stopColor="#4584A3" />
                    <stop offset="0.46" stopColor="#335A7E" />
                    <stop offset="0.6" stopColor="#253A62" />
                    <stop offset="0.75" stopColor="#1B244D" />
                    <stop offset="0.88" stopColor="#151641" />
                    <stop offset="1" stopColor="#13113D" />
                </linearGradient>
                <radialGradient
                    id="paint20_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(142.785 279.036) rotate(-0.122938) scale(103.172 17.5392)"
                >
                    <stop stopColor="#42E8E0" stopOpacity="0" />
                    <stop
                        offset="0.18"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="0.71" stopColor="#42E8E0" />
                    <stop offset="1" stopColor="#D7F9EF" />
                </radialGradient>
                <radialGradient
                    id="paint21_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(8344.74 681.871) scale(4307.51 125.243)"
                >
                    <stop stopColor="#42E8E0" stopOpacity="0" />
                    <stop
                        offset="0.18"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="0.71" stopColor="#42E8E0" />
                    <stop offset="1" stopColor="#D7F9EF" />
                </radialGradient>
                <radialGradient
                    id="paint22_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(6199.18 629.158) rotate(0.122939) scale(2345.99 68.2668)"
                >
                    <stop stopColor="#42E8E0" stopOpacity="0" />
                    <stop
                        offset="0.18"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="0.71" stopColor="#42E8E0" />
                    <stop offset="1" stopColor="#D7F9EF" />
                </radialGradient>
                <linearGradient
                    id="paint23_linear_9907_50791"
                    x1="142.662"
                    y1="331.449"
                    x2="142.662"
                    y2="260.033"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="0.44" stopColor="#42E8E0" />
                    <stop
                        offset="0.86"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <linearGradient
                    id="paint24_linear_9907_50791"
                    x1="94.6798"
                    y1="339.134"
                    x2="189.772"
                    y2="338.183"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#2D5382" />
                    <stop offset="1" stopColor="#3C88C4" />
                </linearGradient>
                <linearGradient
                    id="paint25_linear_9907_50791"
                    x1="163.095"
                    y1="323.171"
                    x2="122.633"
                    y2="386.924"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="#1D9DD7" />
                </linearGradient>
                <linearGradient
                    id="paint26_linear_9907_50791"
                    x1="146.734"
                    y1="4040.67"
                    x2="146.734"
                    y2="5283.09"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop
                        offset="0.82"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint27_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(-6501.92 -38840.3) scale(34.1841 33.7888)"
                >
                    <stop offset="0.01" stopColor="#CFF9FC" />
                    <stop offset="0.41" stopColor="#96F2F1" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint28_linear_9907_50791"
                    x1="519.585"
                    y1="2328.58"
                    x2="519.585"
                    y2="2949.95"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop
                        offset="0.82"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint29_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(-3667.21 -26341.2) scale(16.7683 16.0761)"
                >
                    <stop offset="0.01" stopColor="#CFF9FC" />
                    <stop offset="0.41" stopColor="#96F2F1" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint30_linear_9907_50791"
                    x1="102.893"
                    y1="2905.76"
                    x2="102.893"
                    y2="4260.6"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop
                        offset="0.82"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint31_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(-7175.46 -42851.2) scale(42.1246 41.5849)"
                >
                    <stop offset="0.01" stopColor="#CFF9FC" />
                    <stop offset="0.41" stopColor="#96F2F1" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint32_linear_9907_50791"
                    x1="46.2566"
                    y1="2863.38"
                    x2="46.2566"
                    y2="3464.8"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop
                        offset="0.82"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint33_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(-6658.54 -38418) scale(34.0703 33.4995)"
                >
                    <stop offset="0.01" stopColor="#CFF9FC" />
                    <stop offset="0.41" stopColor="#96F2F1" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint34_linear_9907_50791"
                    x1="586.684"
                    y1="3196.85"
                    x2="586.684"
                    y2="3968.01"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop
                        offset="0.82"
                        stopColor="#42E8E0"
                        stopOpacity="0.25"
                    />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </linearGradient>
                <radialGradient
                    id="paint35_radial_9907_50791"
                    cx="0"
                    cy="0"
                    r="1"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(-4187.68 -30752.9) scale(21.2319 20.8867)"
                >
                    <stop offset="0.01" stopColor="#CFF9FC" />
                    <stop offset="0.41" stopColor="#96F2F1" stopOpacity="0.3" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0" />
                </radialGradient>
                <linearGradient
                    id="paint36_linear_9907_50791"
                    x1="219.129"
                    y1="142.777"
                    x2="235.503"
                    y2="142.777"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint37_linear_9907_50791"
                    x1="3140.39"
                    y1="488.756"
                    x2="3501.84"
                    y2="488.756"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0.3" />
                </linearGradient>
                <linearGradient
                    id="paint38_linear_9907_50791"
                    x1="2257.55"
                    y1="767.155"
                    x2="2452.76"
                    y2="767.155"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#A7F9EF" />
                    <stop offset="0.29" stopColor="#42E8E0" />
                    <stop offset="1" stopColor="#42E8E0" stopOpacity="0.3" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export default lazyNft;
